// Rules-only constants for (standard) Killer. The actual play (number
// assignment, hit resolution, elimination) lives in controller.js - this
// just fixes the choices the setup screen offers and how a finished game is
// ranked.

export const LIVES_OPTIONS = [3, 5, 7];
export const DEFAULT_LIVES = 5;

export const RING_OPTIONS = ['double', 'triple'];
export const DEFAULT_RING = 'double';

export const INCLUDE_BULL_OPTIONS = ['yes', 'no'];
export const DEFAULT_INCLUDE_BULL = 'no';

// Ranked by lives remaining at the moment the game ended - a survivor's own
// life count (1+), same as a still-building non-Killer sitting at 0, an
// eliminated former-Killer at 0, or an eliminated non-Killer at -1. Simple
// numeric sort; ties (e.g. two players both still at 0) just keep player
// order, same as Cricket-style Killer's own ranking.
function rankPlayers(players, scores) {
    return players.slice().sort((a, b) => scores[b] - scores[a]);
}

export default {
    id: 'killer',
    name: 'Killer',
    description: "Everyone starts with zero lives. Hit your own double (or triple, if configured) to become a Killer at full lives - from then on, every one of your hits on that same ring costs someone a life, including your own. One hit ends a player who never became a Killer; a Killer must be brought all the way down to zero.",
    minPlayers: 2,
    // Declares this game's setup-screen options (see app.js's
    // renderConfigRows/getConfigRowValues). The "killer-lives" row id is
    // shared with Cricket-style Killer's own definition (and only that one -
    // namespaced so it can't accidentally collide with some other game's
    // unrelated "lives" concept later) - a row id doubles as its storage
    // key, so both games remember one shared lives preference.
    configRows: [
        {
            id: 'killer-lives',
            label: 'Lives per player',
            default: String(DEFAULT_LIVES),
            numeric: true,
            options: LIVES_OPTIONS.map(value => ({ value: String(value), label: String(value) }))
        },
        // The ring a player must hit, on their own number, to become a
        // Killer, and that a Killer must then hit (on anyone's number,
        // including their own) to actually deal damage.
        {
            id: 'ring',
            label: 'Ring required to kill',
            default: DEFAULT_RING,
            options: RING_OPTIONS.map(value => ({ value, label: value[0].toUpperCase() + value.slice(1) }))
        },
        // Shares its "killer-include-bull" row id with Cricket-style
        // Killer's own definition, same as "killer-lives" above - both
        // games remember one shared choice for it.
        {
            id: 'killer-include-bull',
            label: 'Include Bull/Bullseye',
            default: DEFAULT_INCLUDE_BULL,
            options: INCLUDE_BULL_OPTIONS.map(value => ({
                value,
                label: value === 'yes' ? 'Yes' : 'No',
                description: 'Should the bull/bullseye be eligible when choosing numbers?'
            }))
        }
    ],
    rankPlayers
};
